module.exports = __webpack_public_path__ + "img/29.ba3cc6f2.png";